import { PlusIcon } from "components/icons/PlusIcon";
import { memo } from "react";
import { CrmFilterField } from "types/Models/crmFields";

type CrmAvailableFieldRowProps = {
  field: CrmFilterField;
  onAdd: (fieldKey: string) => void;
};

export const CrmAvailableFieldRow = memo(
  ({ field, onAdd }: CrmAvailableFieldRowProps) => {
    const handleAdd = () => {
      onAdd(field.field_key);
    };

    return (
      <button
        type="button"
        onClick={handleAdd}
        className="t-flex t-w-full t-items-center t-justify-between t-gap-2 t-border-0 t-border-b t-border-solid t-border-neutral-0 t-bg-transparent t-px-3 t-py-2 t-text-left t-text-body-sm t-text-text-60 hover:t-bg-surface-grey"
      >
        <span className="t-truncate">{field.label}</span>
        <span className="t-shrink-0 t-text-purple">
          <PlusIcon size="12" />
        </span>
      </button>
    );
  }
);

CrmAvailableFieldRow.displayName = "CrmAvailableFieldRow";
